<template>
  <svg
    :style="{'width' : + width + 'px', 'height': 'auto'}"
    class="arrow-icon"
    :class="[direction ? 'arrow-icon--' + direction : '']" 
    viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.2288 24.2348C10.8028 23.8206 10.8028 23.1491 11.2288 22.7349L19.1847 15L11.2288 7.26513C10.8028 6.85094 10.8028 6.1794 11.2288 5.76521C11.6548 5.35102 12.3455 5.35102 12.7716 5.76521L21.4988 14.2501C21.9249 14.6642 21.9249 15.3358 21.4988 15.75L12.7716 24.2348C12.3455 24.649 11.6548 24.649 11.2288 24.2348Z" :fill="color"/>
  </svg>
</template>

<script>
export default{
  name: 'ArrowIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '30'
    },
    direction: {
      type: String,
      default: 'right'
    }
  }
}</script>

<style lang="scss" scoped>
.arrow-icon {
  &--right  { transform: rotate(0deg)}
  &--bottom { transform: rotate(90deg)}
  &--left   { transform: rotate(180deg)}
  &--top    { transform: rotate(270deg)}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/ArrowIcon.vue